import axios, { HttpStatusCode } from 'axios';
import apibaseurl from './config';


const apiurl = apibaseurl;
export async function fetchStateCityList() {
    try {
        const response = await axios.get(apiurl + '/api/Binding/GetStateCityList');
        return response.data.Data;
    } catch (error) {
        throw error;
    }
}
export async function fetchBreedList() {
    try {
        const response = await axios.get(apiurl + '/api/Binding/GetBreedList');
        return response.data.Data;
    } catch (error) {
        throw error;
    }
}
export async function fetchEnquiry(obj) {
    try {
        const response = await axios.post(apiurl + '/api/Quotation/GetEnquiryNo', JSON.stringify(obj), {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (response.data.StatusCode == HttpStatusCode.Ok) {

            return response.data;

        } else {

            return [];
        }
    } catch (error) {
        throw error;
    }
}
export async function fetchQuote(obj) {
    try {
        const response = await axios.post(apiurl + '/api/Quotation/GetQuotation', JSON.stringify(obj), {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (response.data.StatusCode == HttpStatusCode.Ok) {

            return response.data.Data;

        } else {

            return [];
        }
    } catch (error) {
        throw error;
    }
}
export async function fetchProposal(obj) {
    try {
        const response = await axios.post(apiurl + '/api/Quotation/GetProposal', JSON.stringify(obj), {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (response.data.StatusCode == HttpStatusCode.Ok) {

            return response.data.Data;

        } else {

            return [];
        }
    } catch (error) {
        throw error;
    }
}
export async function fetchPayment(obj) {
    try {
        const response = await axios.post(apiurl + '/api/Payment/GetPayment', JSON.stringify(obj), {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (response.data.StatusCode == HttpStatusCode.Ok) {

            return response.data.Data;

        } else {

            return [];
        }
    } catch (error) {
        throw error;
    }
}
export async function CallCKYC(obj) {
    try {
        const response = await axios.post('https://uat.smcinsurance.com/api/api/CKYC/FutureCreateCKYC', JSON.stringify(obj), {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (response.status == HttpStatusCode.Ok) {
            return response.data;
        } else {

            return [];
        }
    } catch (error) {
        throw error;
    }
}
export async function fetchPolicyData(GUID) {
    try {
        const response = await axios.get(apiurl + '/api/Payment/GetPolicyStatus?GUID=' + GUID);
        return response.data.Data;
    } catch (error) {
        throw error;
    }
}

export async function centralCall({ URL, Request, IsPost = false, ContentType = "application/json" }) {
    const baseURL=window.location.href.match("localhost")?"":"/pet"
    return await axios.post(`${baseURL}/central/centralcall/${(ContentType === "application/json" ? "CallReqWithHeader" : "CreateProposal")}`, (ContentType === "application/json" ? { URL, Request, IsPost } : Request), {
        headers: {
            'Content-Type': ContentType// 'multipart/form-data',
        }
    });
}